import React from "react";
import classes from "./PageNotFound.module.scss";
import pageNotFoundImage from "../../assets/images/404.jpg";
function PageNotFound() {
  return (
    <div className={classes.pageNotFound}>
      <img src={pageNotFoundImage} alt='404 Page Not Found' />
    </div>
  );
}

export default PageNotFound;
